import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import VoteNotification from './components/VoteNotification';
export default function addNotifications() {
  app.notificationComponents.vote = VoteNotification;
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    var _app$session, _user$canHaveVotingNo;
    const user = (_app$session = app.session) == null ? void 0 : _app$session.user;
    if (!(user != null && (_user$canHaveVotingNo = user.canHaveVotingNotifications) != null && _user$canHaveVotingNo.call(user))) return;
    items.add('vote', {
      name: 'vote',
      icon: 'fas fa-thumbs-up',
      label: app.translator.trans('fof-gamification.forum.notification.prefrences.vote')
    });
  });
}